var React = require('react');

function MicroArrowDown (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"strokeWidth":"2","strokeMiterlimit":"10","points":"1,1 5,5 9,1 "}));
}

MicroArrowDown.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"10px","height":"6px","viewBox":"0 0 10 6","enableBackground":"new 0 0 10 6","xmlSpace":"preserve"};

module.exports = MicroArrowDown;

MicroArrowDown.default = MicroArrowDown;
